$(function () {
  $("#filters_narrow").on('click', function () {
    $(".filters_narrow_list").slideToggle();
    var nowclass = $(this).attr("class");
    console.log(nowclass);
    if (nowclass == 'open') {
      $(this).removeClass("open");
      $(this).addClass("close");
    } else {
      $(this).removeClass("close");
      $(this).addClass("open");
    }
  });
});

$(function () {
  $(".product-form__cart-submit span").each(function () {
    var item_name = $(this).text();
    if (item_name.indexOf("】") > 0) {
      var item_name_before = item_name.slice(0, item_name.indexOf("】") + 1);
      var item_name_after = item_name.slice(item_name.indexOf("】") + 1);
      var item_list_name = item_name_before + "<br>" + item_name_after;
      $(this).html(item_list_name);
    }
  });
});



// .iwachiku_items というclassを持つ要素が存在するかどうかを確認
if (document.querySelector('.iwachiku_items')) {
  // 存在する場合のみ、以下のSwiperスクリプトを実行
  
  var galleryTop_vendar = new Swiper(".iwachiku_items", {
    slidesPerView: 1,
    pagination: {
      el: ".iwa_pagenation", //ページネーションの要素
      type: "bullets", //ページネーションの種類
      clickable: true, //クリックに反応させる
    },
    navigation: {
      nextEl: '.iwa_next',
      prevEl: '.iwa_prev',
    },
  });
}